var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthsunIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 16.5,
    viewBox: "0 0 48 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m47.8908,16.0886c-1.3704-3.4481-3.4966-6.5451-6.222-9.0629C35.2727,1.1642,27.733-1.1048,19.2344.5023,10.5179,2.1534,4.317,7.2518.5228,15.262c-.1843.3914-.3382.7963-.5057,1.1925.1254-.031.2343-.1085.3046-.2168.9909-1.354,2.1169-2.6036,3.3606-3.7298,5.6507-5.1082,12.3476-7.5527,19.9106-7.7387,2.2346-.0456,4.4672.1621,6.6551.619,5.3483,1.0198,10.2966,3.5388,14.268,7.2633,1.2293,1.1621,2.2766,2.5226,3.4056,3.791l.0613-.0542c-.0309-.1008-.0542-.2038-.0921-.3019v.0022Z",
    fill: "#e6a740",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m24.7296,6.4132c-3.5122-.2179-7.0339.2314-10.3789,1.3242-3.5727,1.1377-6.8681,3.0096-9.6748,5.4957-1.1177.9919-2.1009,2.1373-3.1487,3.2127.0195.0195.039.039.0585.0542.0645-.0444.1371-.0808.1957-.1312,3.2317-2.7531,6.8656-4.9954,10.7757-6.6492,3.3027-1.4386,6.7971-2.3891,10.3735-2.8218,1.1312-.1312,2.2711-.1984,3.4083-.2932-.0054-.0309-.0114-.0613-.0168-.0894-.5307-.0336-1.0618-.0699-1.5925-.1035v.0016Z",
    fill: "#e6a740",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthsunIcon);
export default __webpack_public_path__ + "static/media/healthsun-icon.31932984ff0b89101c42d786b39f5574.svg";
export { ForwardRef as ReactComponent };